module.exports = __webpack_public_path__ + "img/sparrow.be5030ca.webp";